module.exports = __webpack_public_path__ + "static/7-d34a84f238b52c0190c23bc39ffc5721.jpg";